import { Protocol } from '../../types/sharedTypeImpl.ts';
import { Change } from './change.ts';
import { ProtocolChanges } from './getProtocolChanges.ts';


interface Props {
    protocolNew: Protocol;
    protocolOld: Protocol;
    changes: ProtocolChanges;
}

export function ProtocolChangesTile({
    protocolNew,
    protocolOld,
    changes,
}: Props) {

    const noChanges = changes.metadataChanges.length === 0 &&
        changes.positionChanges.length === 0 &&
        changes.measurementPlanChanges.length === 0;

    return (
        <div style={{paddingBottom: '24px', }}>
            <h3>{`Version ${protocolOld.version!} → ${protocolNew.version ?? ''}`}</h3>
            <div style={{ marginLeft: '24px' }}>
                <ChangesSection
                    title='Metadata Changes'
                    changes={changes.metadataChanges}
                />
                <ChangesSection
                    title='Position Changes'
                    changes={changes.positionChanges}
                />
                <ChangesSection
                    title='Measurement Plan Changes'
                    changes={changes.measurementPlanChanges}
                />

                {noChanges && (
                    <div className='protocol-change-no-changes'>
                        No changes detected.
                    </div>
                )}
            </div>
        </div>
    );
}


interface ChangesSectionProps {
    title: string;
    changes: Change[];
}
function ChangesSection({ title, changes }: ChangesSectionProps) {
    if (changes.length === 0) {
        return null;
    }

    function getValueTextColor(change: Change): string {
        return change.changeType === 'add' ? '#04aa6d'
            : change.changeType === 'remove' ? '#f00'
                : 'orange';
    }

    return (
        <div style={{ marginTop: '24px' }}>
            <h4 style={{ marginBottom: '8px' }}>{title}</h4>
            {changes.map((change, index) => (
                <div key={index}>
                    <span>
                        {change.path.join(' ')}:
                    </span>
                    <span style={{ color: getValueTextColor(change), marginLeft: '4px' }}>
                        {change.changeDescription}
                    </span>
                </div>
            ))}
        </div>
    );
}
